import { render, staticRenderFns } from "./ProductScreeningPopupIframe.vue?vue&type=template&id=77182d82&"
import script from "./ProductScreeningPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductScreeningPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports